import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { chapterGuide } from "@/mocks/homeContent";

export default function ChapterGuide() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="chapters" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <SectionHeading kicker="Chapter Guide" title={chapterGuide.title} desc={chapterGuide.desc} />

        <div className="mt-10 space-y-4">
          {chapterGuide.volumes.map((volume, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={volume.volume}
                className="overflow-hidden rounded-lg border border-background-200/70 bg-background-100"
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="flex w-full items-center gap-4 px-5 py-5 text-left transition-colors hover:bg-background-200/60"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 font-display text-lg text-background-50">
                      {index + 1}
                    </span>
                    <span className="flex-1">
                      <span className="block text-xs font-medium text-primary-600">{volume.volume}</span>
                      <span className="mt-0.5 block font-heading text-base font-semibold text-foreground-950">
                        {volume.title}
                      </span>
                      <span className="mt-1 block text-sm leading-relaxed text-foreground-500">
                        {volume.summary}
                      </span>
                    </span>
                    <i
                      className={`${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      } shrink-0 text-xl text-foreground-500`}
                    ></i>
                  </button>
                </h3>

                <div
                  className={
                    isOpen
                      ? "border-t border-background-200/70 bg-background-50 px-5 py-5"
                      : "hidden"
                  }
                >
                  <ol className="grid gap-3 sm:grid-cols-2">
                    {volume.chapters.map((chapter) => (
                      <li key={chapter.n} className="flex gap-3 rounded-md bg-background-100 p-3.5">
                        <span className="font-display text-lg leading-none text-accent-700">{chapter.n}</span>
                        <div>
                          <p className="text-sm font-medium text-foreground-900">{chapter.title}</p>
                          <p className="mt-1 text-xs leading-relaxed text-foreground-500">
                            {chapter.summary}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}